import { render, staticRenderFns } from "./ZnNewProject.vue?vue&type=template&id=516e587b&"
import script from "./ZnNewProject.vue?vue&type=script&lang=js&"
export * from "./ZnNewProject.vue?vue&type=script&lang=js&"
import style0 from "./ZnNewProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports